"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Security = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../utils");
var _PasswordForm = require("./PasswordForm");
var _TwoFactor = require("./TwoFactor");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Security = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_PasswordForm.PasswordForm, null), /*#__PURE__*/_react.default.createElement(_TwoFactor.TwoFactor, null));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.greaterThan('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: 502px;\n  "]))));
exports.Security = Security;